export function ucFirst(value: string) {
  if (value.length > 0) {
    return value[0].toUpperCase() + value.substring(1);
  } else {
    return value;
  }
}
